import React from "react";
import { withRouter } from "react-router-dom";
import { GiSewingNeedle } from "react-icons/gi";

class FloatingViewerButton extends React.Component {
  handleOpen = () => {
    this.props.history.push("/embroidery/stitchviewer");
  };

  render() {
    return (
      <>
        <div
          className="floating-viewer-btn"
          onClick={this.handleOpen}
          style={{
            position: "fixed",
            left: "18px",
            bottom: "90px",

            width: "92px",
            height: "92px",

            borderRadius: "50%",
            background: "#e96125",

            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",

            cursor: "pointer",
            zIndex: 999999999,

            boxShadow: "0 10px 30px rgba(253,126,20,0.45)",
            border: "2px solid rgba(255,255,255,0.25)",

            animation: "viewerFloat 2.5s ease-in-out infinite",
          }}
        >
          <GiSewingNeedle size={30} color="#FFFFFF" />

          <span
            style={{
              color: "#FFFFFF",
              fontSize: "10px",
              fontWeight: "700",
              marginTop: "5px",
              letterSpacing: "0.5px",
              textAlign: "center",
              lineHeight: "1.1",
            }}
          >
            Stitch<br />Viewer
          </span>
        </div>

        {/* ✅ INTERNAL CSS */}
        <style>
          {`
            @keyframes viewerFloat {
              0% { transform: translateY(0px); }
              50% { transform: translateY(-6px); }
              100% { transform: translateY(0px); }
            }

            /* ✅ MOBILE FIX */
            @media (max-width: 768px) {
              .floating-viewer-btn {
                width: 62px !important;
                height: 62px !important;

                left: 12px !important;
                bottom: 80px !important;
              }

              .floating-viewer-btn svg {
                font-size: 22px !important;
              }

              .floating-viewer-btn span {
                font-size: 8px !important;
                margin-top: 2px !important;
                line-height: 1 !important;
              }
            }
          `}
        </style>
      </>
    );
  }
}

export default withRouter(FloatingViewerButton);